import personFields from "./personFields";
import { caseReferenceNumberIsUnique, insurancePickerValidator, textFieldDefault } from "../../../validationRules";
import { FormElementProps, FormElementPropsWithoutProduct } from "../../../../components/Case/CaseForm/FormElement";
import { ProductUnion } from "../../../../types/ProductUnion";
import { matchesInsurancePartner } from "../../../partnerReferenceService";

export default function basicCaseInsuranceFields<T extends ProductUnion = ProductUnion>({
  path,
  product,
  isHidden = () => false,
}: Pick<FormElementProps<T>, "path" | "product" | "isHidden">): FormElementPropsWithoutProduct<T>[] {
  return [
    {
      type: "InsurancePicker",
      path: `${path}.insurer`,
      isHidden: isHidden,
      isDisabled: () => matchesInsurancePartner(product.acquisitionPartner, product.caseInsurance.insurer?.insuranceShortName),
      validators: insurancePickerValidator(product),
    },
    {
      type: "ValidatorTextField",
      path: `${path}.caseReferenceNumber`,
      isHidden: isHidden,
      validators: [
        ...textFieldDefault,
        {
          validator: caseReferenceNumberIsUnique,
          params: [product.caseInsurance.caseReferenceNumber, product.id],
          message: "Diese Schadennummer existiert bereits in einem anderen Rechtsfall.",
        },
      ],
    },
    {
      type: "ValidatorTextField",
      path: `${path}.insurancePolicyNumber`,
      isHidden: isHidden,
    },
    {
      type: "ValidatorSelect",
      path: `${path}.policyHolderType`,
      isHidden: isHidden,
      options: () => [{ value: "me" }, { value: "familyMember" }],
    },
    ...personFields<T>({
      path: `${path}.policyHolder`,
      isHidden: ({ product, values }) =>
        isHidden({ product, values }) ||
        !product.caseInsurance.policyHolder ||
        values[product.productClassName].caseInsurance.policyHolderType !== "familyMember",
    }),
  ];
}
